import { forwardRef, useId } from "react"

import type { SX } from "../../theme"
import { TextArea, type TextAreaProps } from "../TextArea/TextArea"
import { FormInputField } from "./FormField"

export interface FormTextAreaProps extends TextAreaProps {
  label?: string
  error?: boolean | string
  description?: string
  sx?: SX
}

export const FormTextArea = forwardRef<HTMLTextAreaElement, FormTextAreaProps>(
  function FormTextArea(props, ref) {
    const { label, sx, error, description, disabled, ...textAreaProps } = props

    const id = useId()

    return (
      <FormInputField
        id={id}
        label={label}
        sx={sx}
        disabled={disabled}
        error={error}
        description={description}
      >
        <TextArea ref={ref} id={id} disabled={disabled} {...textAreaProps} />
      </FormInputField>
    )
  },
)
